// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2080":"d719884f","4092":"d719884f"}[chunkId] + ".chunk.css";
};